module.exports = __webpack_public_path__ + "static/media/non_tick_upi.bc3620f3.svg";